import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="header">
      <div className="container">
        <ul className="header-menu">
          <li>
            <Link className="item-link" to="/">
              صفحه اصلی
            </Link>
          </li>
          <li>
            <Link className="item-link" to="/about">
              درباره ما
            </Link>
          </li>
          <li>
            <Link className="item-link" to="/help">
              راهنمای استفاده
            </Link>
          </li>
          <li>
            <Link className="item-link" to="/faq">
              سوالات متداول
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
